export const clickProductosPersona = (dataLayer, { titulo }) => {
	dataLayer?.push?.({
		'event': 'click-productos-persona',
		'titulo': titulo
	})
}